import { TIMEZONE } from '../constants/currency'
import { timeZones } from '../constants/timezone'
import { getCookie } from './general'

const ELIGIBLE_TIMEZONE_GROUPS = [
  timeZones.US,
  timeZones.UK,
  timeZones.EU,
  timeZones.CA,
  timeZones.AU,
  timeZones.NZ,
  timeZones.SA,
  timeZones.UAE,
  timeZones.SG,
  timeZones.JP,
  timeZones.KR
]

export const isUserFromEligibleCountry = (userTimezone = TIMEZONE) =>
  ELIGIBLE_TIMEZONE_GROUPS.some((group) => group?.includes(userTimezone))

export const isRlTrialOrigin = () => getCookie('signup_origin') === 'rl'

export const hasPreviewModeProject = (liveSites, previewData) =>
  Boolean(previewData?.inPreviewMode) || (Array.isArray(liveSites) && liveSites.some((site) => site?.inPreviewMode))

export const isEligibleForSoloTrial = (userProfile, hasUsedTrial = null, isLoadingTrialStatus = false) => {
  if (!userProfile || !userProfile.email || userProfile?.productId) {
    return false
  }

  if (hasUsedTrial !== null && (hasUsedTrial === null || isLoadingTrialStatus)) {
    return false
  }

  const { userCategory } = userProfile
  const isB2CUser = userCategory === 'B2C'

  const isFromEligibleCountry = isUserFromEligibleCountry() || isRlTrialOrigin()

  const hasCompletedTrial = localStorage.getItem('hasCompletedFreeTrial') === 'true' || hasUsedTrial === true

  return isB2CUser && isFromEligibleCountry && !hasCompletedTrial
}
